import { checkOperationPermission } from '@/utils/permission'

export default {
  inserted (el, binding) {
    const { value } = binding
    if (value) {
      const hasPermission = checkOperationPermission(value)
      if (!hasPermission) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      throw new Error(`Value Error`)
    }
  }
}



// WEBPACK FOOTER //
// ./src/directive/operationPermission.js